export enum Breakpoints {
  Max = 1920,
  Mid = 1365,
  Min = 667
}
